import { connect } from 'react-redux';
import { compose, withState, withHandlers } from 'recompose';
import { injectIntl } from 'react-intl';

import {
  resetErrorsIfNeeded,
  resendOtpCode,
  submitOtpForm,
} from '../../actions/otpForm';
import OtpForm from './OtpForm';

export default compose(
  connect(
    (state) => ({
      status: state.auth.otpForm.status,
      errorCodes: state.auth.otpForm.errorCodes,
      formattedPhoneNumber: state.auth.userInfo.phoneNumber,
    }),
    {
      resetErrorsIfNeeded,
      resendOtpCode,
      submitOtpForm,
    },
  ),

  withState('otpCodeValue', 'setOtpCodeValue', ''),
  withState('isSendOtpAgainEnabled', 'setSendOtpAgainEnabled', false),

  withHandlers({

    handleOtpInputChange: ({ resetErrorsIfNeeded, setOtpCodeValue }) => (otpCodeValue) => {
      resetErrorsIfNeeded();
      setOtpCodeValue(otpCodeValue);
    },

    handleOtpInputFocus: ({ resetErrorsIfNeeded }) => () => {
      resetErrorsIfNeeded();
    },

    handleSendOtpTimerFinish: ({ setSendOtpAgainEnabled }) => () => {
      setSendOtpAgainEnabled(true);
    },

    handleSendOtpAgainButtonClick: ({ resetErrorsIfNeeded, resendOtpCode, setSendOtpAgainEnabled }) => () => {
      resetErrorsIfNeeded();
      resendOtpCode();
      setSendOtpAgainEnabled(false);
    },

    handleFormSubmit: ({ resetErrorsIfNeeded, submitOtpForm, otpCodeValue }) => () => {
      resetErrorsIfNeeded();
      submitOtpForm(otpCodeValue);
    },
  }),

  injectIntl,
)(OtpForm);
